import { CALENDAR_EVENTS_TIMEZONE, IS_INDIAN_EXCHANGE } from 'constants/constants';
import { DateType, getDateTime, add } from 'helpers/day';

/**
 * If the time is on/after the rollover threshold, the event is considered part of the next day.
 * Indian Exchange: 17:30 (5:30 PM)
 * Global Exchange: 12:00 (noon)
 *
 * @param date   Original event date/time.
 * @param format Return format (dayjs format string). Default: `YYYY-MM-DD`.
 * @param tz     Time-zone identifier to use for conversion.
 */
const getEventFormatedDate = (
  date: DateType,
  format: string = 'YYYY-MM-DD',
  tz: string = CALENDAR_EVENTS_TIMEZONE
): string => {
  const dateObj = getDateTime(date, tz);
  const hour = dateObj.hour();
  const minutes = dateObj.minute();

  const shouldRollOver = IS_INDIAN_EXCHANGE
    ? hour > 17 || (hour === 17 && minutes >= 30)
    : hour >= 12;

  const normalized = shouldRollOver ? add(dateObj, 1, 'day') : dateObj;

  return normalized.format(format);
};

/**
 * Similar to `getEventFormatedDate` but returns only the time portion.
 * Applies the same 17:30 roll-over rule.
 */
const getEventFormatedTime = (date: DateType, format: string = 'hh:mm A'): string => {
  const base = getDateTime(date, CALENDAR_EVENTS_TIMEZONE);
  const zoneLabel = CALENDAR_EVENTS_TIMEZONE === 'UTC' ? 'UTC' : 'IST';
  return `${base.format(format)} ${zoneLabel}`;
};

export { getEventFormatedDate, getEventFormatedTime };
